export default (id, paperSize) => (
  window.open(`${process.env.API_LOCATION}/package/barcode/${id}/?token=${localStorage.getItem('id_token')}&paper_size=${paperSize}`)
);



// WEBPACK FOOTER //
// ./src/app/services/package/show.js